import { AtlasBreadcrumb, AtlasBreadcrumbProps } from 'atlas-ds';
import { linkConstructor } from "./link";

export type BreadcrumbProps = AtlasBreadcrumbProps;

export default function Breadcrumb(props: BreadcrumbProps) {
    return <AtlasBreadcrumb
        { ...props }
        linkConstructor={ linkConstructor }
    />
}
